<template>
  <div id="header">
    <div class="logo">
      <img src="@/assets/images/logo.png" alt="" />
    </div>
    <div class="header-right">
      <el-dropdown @command="handleCommand">
        <div class="header-avatar">
          <img src="@/assets/images/my.png" alt="" />
          <div>管理员</div>
          <i class="el-icon-arrow-down"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="退出登录">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    handleCommand(command) {
      if (command == "退出登录") {
        this.loginOut();
      }
    },
    loginOut() {
      this.$confirm("是否退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "成功退出",
          });
          window.sessionStorage.removeItem("token");
          setTimeout(() => {
            this.$router.push("/login");
          }, 1500);
        })
        .catch(() => {});
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
#header {
  width: 100%;
  height: 80px;
  background-color: #000000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 38px 0 49px;
  .logo {
    width: 116px;
    height: 42px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .header-right {
    .header-avatar {
      display: flex;
      align-items: center;
      color: #fff;
      cursor: pointer;
      img {
        width: 27px;
        height: 27px;
      }
      div {
        margin: 0 30px 0 10px;
      }
    }
  }
}
</style>